<as-split *ngIf="!isMobile" direction="horizontal" (dragEnd)="onDragEnd($event)" [gutterDblClickDuration]="300"
          (gutterDblClick)="onDblClickGutter()">
  <as-split-area [size]="splitConfig.gridSize">
    <lib-prod-grid
      [title]="prodGridTitle"
      [icon]="'dataset'"
      [columns]="prodGridColumns"
      [isAddButtonShown]="true"
      [isAddButtonDisabled]="prodGridToolbarButtonsStatus.isAddButtonDisabled.disabled"
      [isEditButtonShown]="true"
      [isRemoveButtonShown]="true"
      [isRemoveButtonDisabled]="prodGridToolbarButtonsStatus.isRemoveButtonDisabled.disabled"
      [headerButtons]="prodGridHeaderButtons"
      [matTableDataSource]="matTableDataSource"
      [inputAction$]="inputAction$"
      [defaultFilter]="defaultFilter"
      (outputAction$)="outputActionEvents($event)"></lib-prod-grid>
  </as-split-area>

  <as-split-area [size]="splitConfig.mapSize">
    <lib-prod-header [title]="prodMapTitle" [icon]="'map'">
      <lib-prod-map #map [markers$]="gridMapService.markers$" [markerSelected$]="gridMapService.markerSelected$"
                    [isMarkersHasCircles]="true"
                    [mapFilter$]="gridMapService.mapFilter$"
                    [mapBounds$]="gridMapService.mapBounds$"
                    (prodMapEvents$)="prodMapEvents($event)"></lib-prod-map>
    </lib-prod-header>
  </as-split-area>
</as-split>

<div *ngIf="isMobile" class="d-flex flex-column cars-wrapper-mobile" style="height: 200%">
  <lib-prod-grid style="height: 50%"
                 [title]="prodGridTitle"
                 [icon]="'dataset'"
                 [columns]="prodGridColumns"
                 [isAddButtonShown]="true"
                 [isAddButtonDisabled]="prodGridToolbarButtonsStatus.isAddButtonDisabled.disabled"
                 [isEditButtonShown]="true"
                 [isRemoveButtonShown]="true"
                 [isRemoveButtonDisabled]="prodGridToolbarButtonsStatus.isRemoveButtonDisabled.disabled"
                 [headerButtons]="prodGridHeaderButtons"
                 [matTableDataSource]="matTableDataSource"
                 [inputAction$]="inputAction$"
                 (outputAction$)="outputActionEvents($event)"></lib-prod-grid>
  <lib-prod-header [title]="prodMapTitle" [icon]="'map'" style="height: 50%">
    <lib-prod-map #map [markers$]="gridMapService.markers$" [markerSelected$]="gridMapService.markerSelected$"
                  [isMarkersHasCircles]="true"
                  [mapFilter$]="gridMapService.mapFilter$"
                  [mapBounds$]="gridMapService.mapBounds$"
                  (prodMapEvents$)="prodMapEvents($event)"></lib-prod-map>
  </lib-prod-header>
</div>
